import { ActivityType } from '@bioliberty/core';
import { getActivityLabel } from '@bioliberty/core/activity';
import { SessionActivitySummary } from '@bioliberty/lifemind';
import { ColumnDef } from '@tanstack/react-table';
import { DataTable } from '../../../components/DataTable';
import { SortableHeader } from '../../../components/DataTable/SortableHeader';
import { formatDate, formatSecondsString } from '../../../util/date';

export function SessionActivityTable({ activities }: { activities: SessionActivitySummary[] }) {
  const hasAssistActivity = activities.some((a) => a.activityTypeId === ActivityType.EXT_MOB_ASSIST);

  let columns = activityColumns;
  if (hasAssistActivity) {
    columns = [...columns, ...assistActivityColumns];
  }

  return (
    <div className="bg-primary overflow-auto py-2 ps-12 brightness-110">
      <DataTable
        rows={activities}
        columns={columns}
        initialSorting={[{ id: 'id', desc: true }]}
        className="min-w-[1000px]"
      />
    </div>
  );
}

const activityColumns: ColumnDef<SessionActivitySummary>[] = [
  {
    accessorKey: 'activityTypeId',
    header: ({ column }) => <SortableHeader column={column}>Activity Type</SortableHeader>,
    cell: ({ row }) => {
      const activityTypeId: string = row.getValue('activityTypeId');
      const gameId: string | undefined = row.original.gameId ?? row.original.cvId ?? undefined;
      return getActivityLabel({ activityTypeId, gameId });
    }
  },
  {
    accessorKey: 'id',
    header: ({ column }) => <SortableHeader column={column}>Activity Start</SortableHeader>,
    cell: ({ row }) => formatDate(new Date(row.getValue('id')))
  },
  {
    accessorKey: 'timeTaken',
    header: ({ column }) => <SortableHeader column={column}>Time on task</SortableHeader>,
    cell: ({ row }) => formatSecondsString(row.getValue('timeTaken'))
  },
  {
    accessorKey: 'totalReps',
    header: ({ column }) => <SortableHeader column={column}>Reps</SortableHeader>
  },
  {
    accessorKey: 'feedbackScore',
    header: ({ column }) => <SortableHeader column={column}>RPE</SortableHeader>,
    cell: ({ row }) => row.getValue('feedbackScore') ?? ''
  }
];

const assistActivityColumns: ColumnDef<SessionActivitySummary>[] = [
  {
    accessorKey: 'independenceScore',
    header: ({ column }) => <SortableHeader column={column}>Independence Score</SortableHeader>
  },
  {
    accessorKey: 'enduranceScore',
    header: ({ column }) => <SortableHeader column={column}>Endurance Score</SortableHeader>
  }
];
